import { Icon } from './mobile';
import * as preact from 'preact';
import { useState } from 'preact/hooks';
import { DirectoryTool } from './tools-directory';
import { CalendarTool } from './tools-calendar';
import { AZTool } from './tools-az';
import { StreamsTool } from './tools-streams';

export function ToolsSidebar() {
	// one of: directory, a-z, calendar, streams
	let tabState = useState('directory');
	let activeTab = tabState[0];
	let setActiveTab = tabState[1];

	return (
		<nav
			id="tools-menu"
			className="tool-nav"
			aria-labelledby="toolsmenu"
			data-js="tools-nav"
			aria-hidden="true"
		>
			<h2 id="toolsmenu" className="u-visual-hide">
				Tools Menus: Directory search, calendar and video streams
			</h2>

			<TopMenu activeTab={activeTab} setActiveTab={setActiveTab} />

			<div className="tools-nav__scrollable">
				<DirectoryTool active={activeTab === 'directory'} />
				<CalendarTool active={activeTab === 'calendar'} />
				<AZTool active={activeTab === 'a-z'} />
				<StreamsTool active={activeTab === 'streams'} />
			</div>
		</nav>
	);
}

function TopMenu({ activeTab, setActiveTab }) {
	return (
		<ul className="tools-nav__select-list u-clearfix" role="tablist">
			<li className="tools-nav__select-item" role="presentation">
				<TopMenuButton
					active={activeTab === 'directory'}
					iconName="directory"
					name={['Show', 'Directory', 'Search']}
					onClick={() => setActiveTab('directory')}
				/>
			</li>

			<li className="tools-nav__select-item" role="presentation">
				<TopMenuButton
					active={activeTab === 'calendar'}
					iconName="calendar"
					name={['Show', 'Calendar']}
					onClick={() => setActiveTab('calendar')}
				/>
			</li>

			<li className="tools-nav__select-item" role="presentation">
				<TopMenuButton
					active={activeTab === 'a-z'}
					iconName="a-z"
					name={['Show', 'A-Z', 'Directory List']}
					onClick={() => setActiveTab('a-z')}
				/>
			</li>

			<li className="tools-nav__select-item" role="presentation">
				<TopMenuButton
					active={activeTab === 'streams'}
					iconName="stream"
					name={['Show', 'Streams', 'Feed']}
					onClick={() => setActiveTab('streams')}
				/>
			</li>
		</ul>
	);
}

function TopMenuButton({ active, iconName, name, onClick }) {
	// let [prefix, main, suffix] = name;
	let prefix = name[0];
	let main = name[1];
	let suffix = name[2];

	let activeName = active ? 'tools-nav__select-trigger--active' : '';

	return (
		<button
			className={`tools-nav__select-trigger tools-nav--focusable ${activeName}`}
			onClick={onClick}
			role="tab"
			type="button"
			aria-selected={active ? 'true' : 'false'}
		>
			<Icon name={iconName} />

			<span className="tools-nav__select-text">
				<span className="u-visual-hide">{prefix} </span>
				{main}
				{suffix && <span className="u-visual-hide"> {suffix}</span>}
			</span>
		</button>
	);
}
